'use strict';

/*
author:gaokaizhi
date:2017-07-19
 */
angular.module('addCustomManuscriptPropModel', [])
    .controller('addCustomManuscriptPropModelCtrl', ['$scope', '$location', '$modal', '$modalInstance', '$stateParams', 'modalDialog', 'trsHttpService', 'existList', '$filter',
        function($scope, $location, $modal, $modalInstance, $stateParams, modalDialog, trsHttpService, existList, $filter) {
            initStatus();
            initData();

            /**
             * [initData description:初始化数据]
             */
            function initData() {
                // 被选择的稿件数据数组
                $scope.itemsChecked = [];
                // 页面ng-repeat的稿件数据数组
                $scope.list = [];
                req();
            }

            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.firstPublish = [{ 'name': '全部', 'value': '1' },
                    { 'name': '新疆在线', 'value': '2' },
                    { 'name': '新疆新闻APP', 'value': '3' },
                    { 'name': '新疆24小时客户端', 'value': '4' },
                    { 'name': '新疆日报', 'value': '5' },
                    { 'name': '新疆晚报', 'value': '6' }
                ];
                $scope.firstPublishDefault = $scope.firstPublish[0];
                $scope.sourceOfArticl = [{ 'name': '全部稿件', 'value': '0' },
                    { 'name': '媒立方稿件  ', 'value': '1' },
                    { 'name': '非媒立方稿件', 'value': '2' }
                ];
                $scope.sourceOfArticlDefault = $scope.sourceOfArticl[0];
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 20,
                    'ITEMCOUNT': 0,
                    'PAGECOUNT': 1
                };
                $scope.status = {
                    'copyCurrPage': 1
                };
                $scope.information = {
                    'beginday': '',
                    'endday': '',
                    'beginindex': '',
                    'endindex': '',
                    'author': '',
                    'title': ''
                };
                var now = new Date();
                now.setMonth(now.getMonth() - 1);  
                $scope.information = {
                    beginday: now,
                    endday: new Date(),
                    beginindex: 0,
                    endindex: 0
                };

            }

            /**
             * [cancel description:通过×关闭稿件添加弹出窗]                         
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [search description:通过搜索按钮发起稿件查询]                         
             */
            $scope.search = function() {
                req();
            };

            /**
             * [selectPageNum description] 单页面显示数据个数
             * @return {[type]} [description]
             */
            $scope.selectPageNum = function() {
                req();
            };

            /**
             * [jumpToPage description] 跳转到指定稿件页            
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                req();
            };

            /**
             * [pageChanged description] 页面切换
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                req();
            };

            /**
             * [req description:添加稿件-检索 ]
             */
            function req() {                
                var dayS = $scope.information.beginday;
                dayS = Date.parse(dayS);
                dayS = $filter('date')(dayS, 'yyyyMMdd').toString();               
                var dayE = $scope.information.endday;
                dayE = Date.parse(dayE);
                dayE = $filter('date')(dayE, 'yyyyMMdd').toString();
                if (isNaN($scope.information.beginindex) || isNaN($scope.information.endindex)){
                    modalDialog.alertType('无法搜索', '指数范围输入非数字', 'error', false);
                    return;
                }
                if ($scope.information.beginindex != ''){
                    var indS = parseFloat($scope.information.beginindex);
                }
                if ($scope.information.endindex != ''){
                    var indE = parseFloat($scope.information.endindex);
                }
                if (dayS > dayE){
                    modalDialog.alertType('无法搜索', '开始时间大于结束时间', 'error', false);
                    return;
                } else if (indS > indE){
                    modalDialog.alertType('无法搜索', '指数范围错误', 'error', false);
                    return;
                }

                var params = {
                    modalname: 'manuScriptsFuncAdd',
                    method: 'searchArticles',
                    methodname: 'queryDataFromBigScreen',
                    serviceid: 'mlf_bigdatascreen',
                    page_no: $scope.page.CURRPAGE - 1,
                    page_size: $scope.page.PAGESIZE,
                    beginday: dayS,
                    endday: dayE,
                    beginindex: indS,
                    endindex: indE,
                    medianame: $scope.firstPublishDefault.name == '全部' ? '' : $scope.firstPublishDefault.name,
                    iscontainmlf: $scope.sourceOfArticlDefault.value,
                    author: $scope.information.author,
                    title: $scope.information.title
                };
                params.beginday;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.list = data.mapResult.content.Records;
                    $scope.page.ITEMCOUNT = data.mapResult.content.totalElements;
                    $scope.page.PAGECOUNT = data.mapResult.content.totalPages;
                    if (existList.length != 0) {
                        var a = 0;
                        var i = 0;
                        for (i = 0; i < $scope.list.length; i++) {
                            for (a = 0; a < existList.length; a++) {
                                if ($scope.list[i].zbGuid == existList[a].zbGuid) {
                                    break;
                                }
                            }
                            if (a < existList.length) {
                                $scope.itemsChecked.push($scope.list[i]);
                            }
                        }
                    }
                });
            }

            /**
             * [checkItems description:通过用户点击选中或取消选中稿件 ]
             */
            $scope.checkItems = function(tpl) {
                for (var s = 0; s < existList.length; s++) {
                    if (existList[s].zbGuid == tpl.zbGuid) {
                        existList.splice(s, 1);
                        break;
                    }
                }
                for (var i = 0; i < $scope.itemsChecked.length; i++) {
                    if ($scope.itemsChecked[i].zbGuid == tpl.zbGuid) {
                        $scope.itemsChecked.splice(i, 1);
                        return;
                    }
                }
                $scope.itemsChecked.push(tpl);
            };

            /**
             * [isChk description:判断列表中的稿件是否被选中 ]
             */
            $scope.isChk = function(tpl) {
                for (var i = 0; i < $scope.itemsChecked.length; i++) {
                    if ($scope.itemsChecked[i].zbGuid == tpl.zbGuid) {
                        return true;
                    }
                }
                return false;
            };

            /**
             * [checkAll description:选择列表中全部稿件 ]
             */
            $scope.checkAll = function() {
                $scope.itemsChecked = $scope.list.slice(0, $scope.list.length);
            };

            /**
             * [checkReverse description:反选列表中全部稿件 ]
             */
            $scope.checkReverse = function() {
                var a = 0;
                var i = 0;
                var copyList = [];
                for (i = 0; i < $scope.list.length; i++) {
                    for (a = 0; a < $scope.itemsChecked.length; a++) {
                        if ($scope.list[i].zbGuid == $scope.itemsChecked[a].zbGuid) {
                            break;
                        }
                    }
                    if (a == $scope.itemsChecked.length) {
                        copyList.push($scope.list[i]);
                    }
                }
                $scope.itemsChecked.splice(0, $scope.itemsChecked.length);
                $scope.itemsChecked = copyList.splice(0, copyList.length);
            };

            /**
             * [addManuscript description:添加选中稿件]
             */
            $scope.addManuscript = function() {
                var hash = {};
                var copy = [];
                var params = {
                    modalname: 'manuScriptsFuncAdd',
                    method: 'addSelectedArticles',
                    methodname: 'queryDataFromBigScreen',
                    serviceid: 'mlf_bigdatascreen',
                    selected_guids: '',
                    manuscripts_search_guids: '',
                    id: $stateParams.id
                };
                $scope.itemsChecked = existList.concat($scope.itemsChecked);
                jQuery.each($scope.itemsChecked, function(index, val) {
                    if (hash[val.zbGuid] === undefined) {
                        hash[val.zbGuid] = true;
                        copy.push(val);
                    }
                });
                $scope.itemsChecked = copy.slice(0, copy.length);
                if ($scope.itemsChecked.length == 0) {
                    modalDialog.alertType('添加失败', '请选择稿件', 'error', false);
                    return;
                } else if ($scope.itemsChecked.length > 100) {
                    modalDialog.alertType('提交失败', '稿件不能超过100条', 'error', false);
                    return;
                }
                jQuery.each($scope.itemsChecked, function(index, val) {
                    params.selected_guids += val.zbGuid;
                    params.selected_guids += ',';
                });
                params.selected_guids = params.selected_guids.slice(0, params.selected_guids.length - 1);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    if (data.mapResult.status = 'SUCCESS') {
                        var recData = data.mapResult.content;
                        modalDialog.confirmModal('添加稿件', '添加成功', function() {
                            $modalInstance.close(recData);
                        });
                    }
                });
            };
        }
    ]);
